// Shared viewer client — token & API helpers (separate from main SMNGP auth)
import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const LS_TOKEN_KEY = 'live_viewer_token';
export const LS_VIEWER_KEY = 'live_viewer_meta';

export const getViewerToken = () => localStorage.getItem(LS_TOKEN_KEY) || '';
export const setViewerToken = (t) => localStorage.setItem(LS_TOKEN_KEY, t);
export const clearViewer = () => {
  localStorage.removeItem(LS_TOKEN_KEY);
  localStorage.removeItem(LS_VIEWER_KEY);
};
export const getViewerMeta = () => {
  try { return JSON.parse(localStorage.getItem(LS_VIEWER_KEY) || 'null'); } catch { return null; }
};
export const setViewerMeta = (m) => localStorage.setItem(LS_VIEWER_KEY, JSON.stringify(m));

// Clear cached assets (Cache Storage) and any service worker so a stale build
// can't cause UI issues. Preserves the viewer token/meta in localStorage.
export const clearAppCaches = async () => {
  try {
    if (typeof window !== 'undefined' && 'caches' in window) {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((k) => window.caches.delete(k)));
    }
  } catch { /* ignore */ }
  try {
    if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map((r) => r.unregister()));
    }
  } catch { /* ignore */ }
};

export const liveApi = () => {
  const t = getViewerToken();
  const ax = axios.create({ baseURL: API, headers: t ? { Authorization: `Bearer ${t}` } : {} });
  // Intercept 409 (single-session kicked) and redirect
  ax.interceptors.response.use((r) => r, (err) => {
    if (err?.response?.status === 409) {
      clearViewer();
      const msg = err.response.data?.detail || 'Logged in from another device';
      // Throw to caller with a friendly flag
      err._kicked = true;
      err._friendly = msg;
    }
    return Promise.reject(err);
  });
  return ax;
};
